module.exports = __webpack_public_path__ + "static/media/Sopalomito.fc82d0a6.jpg";